export default "__VITE_ASSET__Cjuy232r__"